/* eslint-disable */
import { store } from '../../store'
import { http, httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  async activeInactiveUser({ commit }, { id, activeInactive, event, ctx }) {
    const url = `api/user/${id}/set-active-inactive`
    const options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    try {
      await http.put(url, { active: activeInactive }, options).then(
        response => {
          event.context.showNotification(response.data.message, 'success')
        }
      )
      ctx.getRefresh()
      // ctx.loadingChangeStatus = false
      // ctx.initialize()
      // location.reload()
    } catch (error) {
      ctx.loadingChangeStatus = false
      commit('onError', { event: event, error: error })
    }
  },
  get({ commit, dispatch }, payload) {
    let url = 'api/user'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onGet', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  post({ commit, dispatch }, payload) {
    let avatar = null
    if (payload.event.item.user_info.avatar !== '') {
      avatar = payload.event.item.user_info.avatar
    } else {
      avatar = undefined
    }
    let birthdate = null
    if (payload.event.item.user_info.birthdate !== '') {
      birthdate = payload.event.item.user_info.birthdate
    } else {
      birthdate = undefined
    }
    let url = 'api/user'
    let params = {
      name: payload.event.item.name,
      email: payload.event.item.email,
      password: payload.event.item.password,
      phone: payload.event.item.user_info.phone,
      address: payload.event.item.user_info.address,
      //VERIFICAR SI SE REMUEVE DE AQUÍ
      employee_number: payload.event.item.user_info.employee_number,
      cost_center: payload.event.item.user_info.cost_center,
      policy_address: payload.event.item.user_info.policy_address,
      deposit_bank: payload.event.item.user_info.deposit_bank,
      bank_account: payload.event.item.user_info.bank_account,
      sat_pais_id: payload.event.item.user_info.sat_pais_id,
      avatar: avatar,
      gender: payload.event.item.user_info.gender,
      birthdate: birthdate,
      branch_id: payload.event.item.user_info.branch_id,
      company_id: payload.event.item.company[0].id,
      role_id: payload.event.item.roles[0].id,
      card_number: payload.event.item.card_number,
      tax_id: payload.event.item.user_info.tax_id,
      rfc: payload.event.item.user_info.rfc
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.post(url, params, {}).then(
      response => {
        commit('onPost', { event: payload.event, response: response })
      },
      error => {
        commit('onPostError', { event: payload.event, error: error })
      }
    )
  },
  put({ commit, dispatch }, payload) {
    let email = null
    if (payload.event.item.email !== payload.event.item.email_original) {
      email = payload.event.item.email
    } else {
      email = undefined
    }
    let avatar = null
    if (payload.event.avatarId !== null) {
      avatar = payload.event.avatarId
    } else if (payload.event.item.user_info.avatar !== null) {
      avatar = payload.event.item.user_info.avatar.id
    } else {
      avatar = undefined
    }
    let birthdate = null
    if (payload.event.item.user_info.birthdate !== null) {
      birthdate = payload.event.item.user_info.birthdate
    } else {
      birthdate = undefined
    }
    let url = 'api/user/' + payload.event.item.id
    let params = {
      name: payload.event.item.name,
      email: email,
      password: payload.event.item.password,
      phone: payload.event.item.user_info.phone,
      address: payload.event.item.user_info.address,
      employee_number: payload.event.item.user_info.employee_number,
      cost_center: payload.event.item.user_info.cost_center,
      policy_address: payload.event.item.user_info.policy_address,
      deposit_bank: payload.event.item.user_info.deposit_bank,
      bank_account: payload.event.item.user_info.bank_account,
      sat_pais_id: payload.event.item.user_info.sat_pais_id,
      avatar: avatar,
      gender: payload.event.item.user_info.gender,
      birthdate: birthdate,
      branch_id: payload.event.item.user_info.branch_id,
      card_number: payload.event.item.card_number,
      tax_id: payload.event.item.user_info.tax_id,
      rfc: payload.event.item.user_info.rfc
    }
    
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.put(url, params, {}).then(
      response => {
        commit('onPut', { event: payload.event, response: response })
      },
      error => {
        commit('onPutError', { event: payload.event, error: error })
      }
    )
  },
  delete({ commit, dispatch }, payload) {
    let url = 'api/user/' + payload.event.item.id
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {}).then(
      response => {
        commit('onDelete', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getLogged({ commit, dispatch }, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options).then(
      response => {
        commit('onGetLogged', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getByCompany({ commit, dispatch }, payload) {
    let order = payload.event.context.pagination.descending ? 'asc' : 'desc'

    let orderBy = payload.event.context.pagination.sortBy === 'status' ? 'active' : payload.event.context.pagination.sortBy

    let url = payload.event.context.userSearch === '' || payload.event.context.userSearch === undefined
            ? `api/user/by-company/${payload.event.company_id}?page=${payload.event.context.pagination.page}&perPage=${payload.event.context.pagination.rowsPerPage}&order=${order}&orderBy=${orderBy}`
            : `api/user/by-company/${payload.event.company_id}?page=${payload.event.context.pagination.page}&perPage=${payload.event.context.pagination.rowsPerPage}&order=${order}&orderBy=${orderBy}&find=${payload.event.context.userSearch}`
    
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        commit('onGetByCompany', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getMassiveTemplate({ commit, dispatch }, payload) {
    let url = `api/user/massive/get-template`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      responseType: 'blob'
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, params, options).then(
      response => {
        commit('onGetMassiveTemplate', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onGetMassiveTemplateError', {
          event: payload.event,
          error: error
        })
      }
    )
  },
  postMassiveValidate({ commit, dispatch }, payload) {
    let url = `api/user/massive/validate`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.post(url, {}, options).then(
      response => {
        commit('onPostMassiveValidate', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  postMassiveCreate({ commit, dispatch }, payload) {
    let url = `api/user/massive/create`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      users: payload.event.users
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.post(url, params, options).then(
      response => {
        commit('onPostMassiveCreate', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onPostMassiveCreateError', {
          event: payload.event,
          error: error
        })
      }
    )
  },
  async downloadReport({ commit }, { event }) {
    try {
      const url = `api/areas-users/report`
      
      const options = { emulateJSON: false, headers: { 'Content-Type': `application/xlsx` } }
      
      const params = { responseType: 'blob' }
      
      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token

      const response = await httpgst.get(url, params, options)
      
      const reportBinary = response.data
      
      event.context.forceFileDownload(reportBinary, `report-users.xlsx`)

    } catch (error) {
      console.log(error)
      event.context.showNotification(error.response, 'error')
    } finally {
      event.context.loadingExcelReport = false
    }
  }
}

// mutations
const mutations = {
  // Set the data obtained from the users endpoint
  onGet(state, payload) {
    let users = payload.response.data.data
    users.forEach(element => {
      element.email_original = element.email
      element.company_original = Object.assign({}, element.company)
      // element.role_original = Object.assign({}, element.roles)
      element.area_original = Object.assign({}, element.area)
      // element.branch_id = element.user_info.branch_id
    })
    payload.event.context.users = users
    payload.event.context.loadingChangeStatus = false
    payload.event.context.loadingItems = false
  },
  // Add the data from the new user to the users list
  onPost(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    let user = payload.response.data.data
    let company = payload.event.item.company[0]
    let roles = payload.event.item.roles[0]
    let area = payload.event.item.area[0]
    let url = 'api/user-company'
    let params = {
      user_id: user.id,
      company_id: company.id
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.post(url, params).then(
      response => {
        let url = 'api/user-role'
        let params = {
          user_id: user.id,
          role_id: roles.id
        }
        http.defaults.headers.common['Authorization'] =
          'Bearer ' + store.state.userState.access_token
        http.post(url, params, {}).then(
          response => {
            let url = 'api/areas-users'
            let params = {
              user_id: user.id,
              gst_area_id: area.id
            }
            httpgst.defaults.headers.common['Authorization'] =
              'Bearer ' + store.state.userState.access_token
            httpgst.post(url, params, {}).then(
              response => {
                let event = payload.event
                event.item = {
                  user: user,
                  application: payload.event.item.application
                }
                this.dispatch('userApplication/post', { event: event }).then(
                  resolve => {
                    setTimeout(() => {
                      payload.event.context.close()
                      payload.event.context.refresh()
                    }, 3000)
                  }
                )
              },
              error => {
                this.commit('onError', { event: payload.event, error: error })
              }
            )
          },
          error => {
            this.commit('onError', { event: payload.event, error: error })
          }
        )
      },
      error => {
        this.commit('onError', { event: payload.event, error: error })
      }
    )
    payload.event.context.loadingItems = true
  },
  // Updates the data displayed for the modified user
  onPut(state, payload) {
    let user = payload.response.data.data
    let roles = payload.event.item.roles[0]
    let rolOriginal = payload.event.item.rol_original
    let area = payload.event.item.area[0]
    let areaOriginal = payload.event.item.area_original[0]
    user.name_original = user.name
    user.email_original = user.email
    payload.event.newArea = area
    let application = payload.event.item.application
    let applicationOriginal = payload.event.item.application_original
    if (roles && rolOriginal && roles !== rolOriginal) {
      this.dispatch('userRole/post', {
        event: payload.event,
        user: user,
        roles: roles
      })
    }
    if (
      application !== undefined &&
      applicationOriginal !== undefined &&
      application !== applicationOriginal
    ) {
      let event = payload.event
      event.item = { user: user, application: application }
      this.dispatch('userApplication/post', { event: event })
    }
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    setTimeout(() => {
      payload.event.context.refresh()
    }, 3000)
    payload.event.context.loadingItems = true
  },
  // Removes the data of the deleted user from the users list
  onDelete(state, payload) {
    // let users = payload.event.context.users
    // users.splice(payload.event.index, 1)
    // payload.event.context.users = users
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.loadingItems = true
    payload.event.context.closeDelete()
    payload.event.context.refresh()
  },
  // Shows a error message
  onError(state, payload) {
    // payload.event.context.setMessage(payload.error.response.data.message)
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loadingChangeStatus = false
    payload.event.context.loadingItems = false
  },
  // Shows a error message
  onPostError(state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.closeConfirmAdd()
    payload.event.context.loading = false
  },
  // Shows a error message
  onPutError(state, payload) {
    // payload.event.context.setMessage(payload.error.response.data.message)
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
  },
  onGetLogged(state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
  },
  onGetByCompany(state, payload) {
    let users = payload.response.data.data.data
    users.forEach(element => {
      element.email_original = element.email
      element.company_original = Object.assign({}, element.company)
      element.area_original = Object.assign({}, element.area)
    })
    payload.event.context.users = users
    // payload.event.context.users = payload.response.data.data
    payload.event.context.loadingChangeStatus = false
    payload.event.context.loadingItems = false

    payload.event.context.pagination.rowsPerPage = parseInt(payload.response.data.data.per_page)
    payload.event.context.pagination.page = payload.response.data.data.current_page
    payload.event.context.pagination.totalItems = payload.response.data.data.total
    payload.event.context.pagination.lastPage = payload.response.data.data.last_page;
  },
  onGetMassiveTemplate(state, payload) {
    payload.event.context.forceFileDownload(
      payload.response.data,
      'usersTemplate.xlsx'
    )
    payload.event.context.loading = false
  },
  onGetMassiveTemplateError(state, payload) {
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
  },
  onPostMassiveValidate(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
  },
  onPostMassiveCreate(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeBatch()
  },
  onPostMassiveCreateError(state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.usersBatchErrors =
        payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
  },
  onDownloadReport(state, payload) {
    payload.event.context.forceFileDownload(
      payload.response.data,
      'usersReport.xlsx'
    )
    payload.event.context.loading = false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js